module.exports = __webpack_public_path__ + "static/media/search-icon.ce9f6429.svg";